import React from 'react';
import { string } from 'prop-types';
import { Alert, Link } from '@one-thd/sui-atomic-components';

export const CornerCabinetInfoMessage = ({ cabinetType, itemId }) => {
  /*
  "Corner Blind"
  "Corner Lazy Susan"
  "Corner Standard"
  "Corner Diagonal"
  */
  if (['Corner Lazy Susan', 'Corner Standard'].includes(cabinetType)) {
    return (
      <div className="sui-flex sui-flex-col sui-w-full sui-pt-3">
        <Alert status="info">
          {`This type of corner cabinet typically installs in a 36" x 36" wall area.
          Please doublecheck manufacturer specs to ensure exact measuring requirements. `}
          <Link href={`https://www.homedepot.com/p/${itemId}`} target="_blank" variant="body-base">
            See Product Details
          </Link>
        </Alert>
      </div>
    );
  }
  if (['Corner Blind'].includes(cabinetType)) {
    return (
      <div className="sui-flex sui-flex-col sui-w-full sui-pt-3">
        <Alert status="info">
          {`Corner Blind cabinets typically require 6" of additional install clearance. 
          Please doublecheck manufacturer specs to ensure exact measuring requirements. `}
          <Link href={`https://www.homedepot.com/p/${itemId}`} target="_blank" variant="body-base">
            See Product Details
          </Link>
        </Alert>
      </div>
    );
  }
  return null;

};

CornerCabinetInfoMessage.propTypes = {
  cabinetType: string,
  itemId: string
};

CornerCabinetInfoMessage.defaultProps = {
  cabinetType: '',
  itemId: ''
};